import { FC } from 'react';

import { PlaceholderBar } from '../../components/loading-skeleton/index';

type ScenarioModelingPlaceholderProps = {
  cards?: number;
};

export const ScenarioModelingPlaceholder: FC<ScenarioModelingPlaceholderProps> = ({
  cards = 6,
}) => (
  <div className="flex w-full animate-pulse flex-col gap-4 xlg:min-h-[86vh]">
    <div className="flex items-center justify-between gap-4">
      <PlaceholderBar className="h-6 w-40 rounded bg-gray-100" />
      <PlaceholderBar className="h-9 w-40 rounded bg-gray-100" />
    </div>
    <div className="flex w-full flex-wrap gap-4">
      {Array.from({ length: cards }).map((_, index) => (
        <div
          className="flex w-full flex-col gap-4 rounded-lg p-4 shadow-sm xlg:max-w-[286px] lg:max-w-[404px]"
          key={index}
        >
          <PlaceholderBar className="h-32 w-full rounded-md bg-gray-100" />
          <PlaceholderBar className="h-5 w-3/4 rounded bg-gray-100" />
          <PlaceholderBar className="h-4 w-1/2 rounded bg-gray-100" />
        </div>
      ))}
    </div>
  </div>
);
